import { Component, Input } from '@angular/core';

import {
  ContentAlignment,
  ContentMediaScale,
  ContentPattern,
  ContentTheme,
} from '../../models';
import { BrandPatternComponent } from '../brand-pattern/brand-pattern.component';

@Component({
  selector: 'wl-partial-media-section',
  templateUrl: './media-section.component.html',
  styleUrls: ['./media-section.component.ed.scss'],
  standalone: true,
  imports: [BrandPatternComponent],
})
export class MediaSectionComponent {
  // @NOTE: when we refactor the BCC brand wide,
  // consider changing alignment options to start and end?
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mediaPosition: ContentAlignment = 'left';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mediaScale: ContentMediaScale = 'md';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() theme: ContentTheme = 'default';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() pattern?: ContentPattern;
}
